import { MathUtils } from '@shared/utils/MathUtils';
import { InstrumentTypes } from '@shared/utils/Instruments/InstrumentTypes';
import { OffsetModeViewEnum } from '@shared/utils/Trading/OffsetModeViewEnum';
var VariableTickMovemementType;
(function (VariableTickMovemementType) {
    VariableTickMovemementType[VariableTickMovemementType["Unknown"] = 0] = "Unknown";
    VariableTickMovemementType[VariableTickMovemementType["Left"] = 1] = "Left";
    VariableTickMovemementType[VariableTickMovemementType["Right"] = 2] = "Right";
})(VariableTickMovemementType || (VariableTickMovemementType = {}));
class TicksUtils {
    /// <summary>
    /// метод предназначен для нахождения цены для инструмента с переменным тик сайзом
    /// кол-во тиков должено быть передано со знаком, для то чтобы мы понимали в какую стороную его нужно откладывать
    /// </summary>
    CalculatePrice(basisPrice, numberOfTicks, variableTickList, isAllowFractionalTick, offsetType) {
        const moveType = numberOfTicks > 0 ? VariableTickMovemementType.Right : VariableTickMovemementType.Left;
        const basisPriceDec = this.RoundPriceToNearestPointSize(basisPrice, variableTickList);
        const tick = this.FindVariableTick(basisPriceDec, variableTickList);
        if (numberOfTicks === 0) {
            return basisPriceDec;
        }
        const basisPriceDecObj = { value: basisPriceDec };
        const numberOfTicksObj = { value: Math.abs(numberOfTicks) };
        this.CalculatePriceAction(tick, moveType, basisPriceDecObj, numberOfTicksObj, variableTickList, isAllowFractionalTick, offsetType);
        const newTick = this.FindVariableTick(basisPriceDecObj.value, variableTickList);
        return this.roundToDecimalPlaces(basisPriceDecObj.value, newTick.PointSize);
    }
    /// <summary>
    /// Округлить цену, до тиксайза соответствующего диапозона
    /// </summary>
    RoundPriceToNearestPointSize(price, variableTickList) {
        const tick = this.FindVariableTick(price, variableTickList);
        let roundedPrice;
        if (tick === null) {
            roundedPrice = MathUtils.RoundToIncrement(price, -1);
        }
        else {
            roundedPrice = MathUtils.RoundToIncrement(price, tick.PointSize);
        }
        return this.roundToDecimalPlaces(roundedPrice, tick.PointSize);
    }
    FindVariableTick(price, variableTickList) {
        for (let i = variableTickList.length - 1; i >= 0; i--) {
            const tick = variableTickList[i];
            if (tick.CheckPrice(price)) {
                return tick;
            }
        }
        console.log('Fail to find VariableTick');
        return null;
    }
    AllowUseFractinalTicksForForex(instrType) {
        return instrType == InstrumentTypes.FOREX;
    }
    GetPipsSize(pointSize, isAllowFractionalTick, offsetType) {
        // +++ http://tp3.pfsoft.lan/entity/23544
        if (offsetType !== OffsetModeViewEnum.TicksFractionalForForex || !isAllowFractionalTick) {
            return pointSize;
        }
        if (Math.round(Math.log(pointSize) / Math.log(10)) % 2 === 0) {
            return pointSize;
        }
        else {
            return pointSize * 10;
        }
    }
    getNextInterval(tick, variableTickList) {
        let currentIndex = variableTickList.indexOf(tick);
        return currentIndex < variableTickList.length - 1 ? variableTickList[++currentIndex] : variableTickList.at(-1);
    }
    getPrevInterval(tick, variableTickList) {
        let currentIndex = variableTickList.indexOf(tick);
        return currentIndex > 0 ? variableTickList[--currentIndex] : variableTickList[0];
    }
    /// <summary>
    /// абсолютный оффест должен быть передан со знаком, чтобы мы понимали, в какую сторону он откладывался
    /// </summary>
    CalculateTicks(basisPrice, absoluteOffset, variableTickList, isAllowFractionalTick, offsetType) {
        // RENAME everywhere TO CalculateTicks
        const basisPriceDec = this.RoundPriceToNearestPointSize(basisPrice, variableTickList);
        const moveType = absoluteOffset > 0 ? VariableTickMovemementType.Right : VariableTickMovemementType.Left;
        const tick = this.FindVariableTick(basisPriceDec, variableTickList);
        const numberOfTicks = { value: 0 };
        const basisPriceObj = { value: basisPriceDec };
        const absoluteOffsetObj = { value: Math.abs(absoluteOffset) };
        this.CalculateOffsetAction(tick, moveType, basisPriceObj, absoluteOffsetObj, numberOfTicks, variableTickList, isAllowFractionalTick, offsetType);
        return MathUtils.RoundDouble(numberOfTicks.value, 1);
    }
    CalculateOffsetAction(tick, moveType, basisPrice, absoluteOffset, numberOfTicks, variableTickList, isAllowFractionalTick, offsetType) {
        // здесь мы получаем количество новую базовую цену, остаток оффсета и кол-во уже отложенных тиков
        this.ProcessOffsset(tick, moveType, basisPrice, absoluteOffset, numberOfTicks, isAllowFractionalTick, offsetType);
        // если у нас остался оффсет - переходим к следующему интервалу
        if (absoluteOffset.value > 0) {
            const newTick = moveType == VariableTickMovemementType.Left
                ? ticksUtils.getPrevInterval(tick, variableTickList)
                : ticksUtils.getNextInterval(tick, variableTickList);
            this.CalculateOffsetAction(newTick, moveType, basisPrice, absoluteOffset, numberOfTicks, variableTickList, isAllowFractionalTick, offsetType);
        }
    }
    CalculatePriceAction(tick, moveType, basisPrice, numberOfTicks, variableTickList, isAllowFractionalTick, offsetType) {
        // здесь мы получаем количество оставшихся тиков и новую базовую цену
        this.ProcessTicks(tick, moveType, basisPrice, numberOfTicks, isAllowFractionalTick, offsetType);
        // если у на остались тики переходим к следующему интервалу
        if (numberOfTicks.value > 0) {
            const newTick = moveType === VariableTickMovemementType.Left
                ? this.getPrevInterval(tick, variableTickList)
                : this.getNextInterval(tick, variableTickList);
            this.CalculatePriceAction(newTick, moveType, basisPrice, numberOfTicks, variableTickList, isAllowFractionalTick, offsetType);
        }
    }
    /// <summary>
    /// Сдвигаем цену (basisPrice) на количество тиков (numberOfTicks) в пределах диапозона (tick)
    /// </summary>
    ProcessTicks(tick, moveType, basisPrice, numberOfTicks, isAllowFractionalTick, offsetType) {
        const price = basisPrice.value +
            (moveType === VariableTickMovemementType.Right ? 1 : -1) *
                numberOfTicks.value *
                this.GetPipsSize(tick.PointSize, isAllowFractionalTick, offsetType);
        if (tick.CheckPrice(price)) {
            numberOfTicks.value = 0;
            basisPrice.value = price;
        }
        else {
            const border = moveType === VariableTickMovemementType.Right ? tick.RightBorder : tick.LeftBorder;
            const ticksToBorder = Math.abs(border - basisPrice.value) / this.GetPipsSize(tick.PointSize, false, offsetType);
            numberOfTicks.value = numberOfTicks.value - ticksToBorder;
            basisPrice.value = border;
        }
    }
    ProcessOffsset(tick, moveType, basisPrice, absoluteOffset, numberOfTicks, isAllowFractionalTick, offsetType) {
        let tickCount;
        const price = basisPrice.value + (moveType == VariableTickMovemementType.Right ? 1 : -1) * absoluteOffset.value;
        if (tick.CheckPrice(price)) {
            basisPrice.value = price;
            tickCount =
                absoluteOffset.value / ticksUtils.GetPipsSize(tick.PointSize, isAllowFractionalTick, offsetType);
            absoluteOffset.value = 0;
        }
        else {
            const border = moveType == VariableTickMovemementType.Right ? tick.RightBorder : tick.LeftBorder;
            const offset = Math.abs(border - basisPrice.value);
            absoluteOffset.value -= offset;
            basisPrice.value = border;
            tickCount = offset / ticksUtils.GetPipsSize(tick.PointSize, false, offsetType);
        }
        numberOfTicks.value += tickCount;
    }
    roundToDecimalPlaces(value, pointSize) {
        const decimalPlaces = MathUtils.GetDecimalPlaces(pointSize, 20);
        const newValue = value.toFixed(decimalPlaces);
        return Number(newValue);
    }
}
export const ticksUtils = new TicksUtils();
